"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const KPI = _ref => {
  let {
    children,
    color,
    className,
    size,
    title,
    type
  } = _ref;
  const classNames = (0, _classnames.default)({
    [`is-${color}`]: color,
    [`${size}`]: size,
    [`${type}`]: type
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('kpi', className, classNames) || undefined
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "kpi--border-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "kpi--title"
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: "kpi--data"
  }, children)));
};
KPI.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  className: _propTypes.default.string,
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'info', 'link', 'success', 'warning', 'danger']), _propTypes.default.string]),
  title: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  type: _propTypes.default.string,
  size: _propTypes.default.oneOf(['large', 'medium', 'small'])
};
KPI.defaultProps = {
  className: '',
  type: '',
  title: ''
};
var _default = exports.default = KPI;
//# sourceMappingURL=KPI.js.map